module.exports = __webpack_public_path__ + "img/c_3.50beb96b.png";